<ng-container *ngIf="(media === 'xs' || media === 'sm') else deskmode">
    <div class="calcontainermobile">
        <div style="color: #102e46;font-weight: 900;font-size: 19px;">Ferientermine</div>
        <div class="state-selector" style="margin: 10px 0;">
            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label multilang>Bundesland</mat-label>
                <mat-select [(ngModel)]="selectedState" (selectionChange)="onStateChange()">
                    <mat-option *ngFor="let state of germanStates" [value]="state.code">
                        {{ state.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <ng-container *ngFor="let cal of calendars | async;trackBy: trackByFn">
            <div [id]="cal.class">
                <div class="month_header-mobile">
                    <span multilang>{{cal.header | date: 'MMMM, yyyy'}}</span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:cal}"></ng-container>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-template #deskmode>
    <div class="calwrapper">
        <div style="color: #102e46;font-weight: 900;font-size: 19px;">Ferientermine</div>
        <div class="state-selector" style="margin: 10px 0;">
            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label multilang>Bundesland</mat-label>
                <mat-select [(ngModel)]="selectedState" (selectionChange)="onStateChange()">
                    <mat-option *ngFor="let state of germanStates" [value]="state.code">
                        {{ state.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="d-header-wrapper">
            <span multilang>{{start | date:'EEE dd.MM.yyyy'}} {{!isOne ? ' - ' + (end | date:'EEE dd.MM.yyy') :
                ''}}</span>
        </div>
        <div class="calcontainer">
            <div class="first-cal-wrapper">
                <div class="month_header">
                    <button (click)="previus()" class="dirbtn" matRipple>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span multilang class="header-txt">{{first_header | date: 'MMMM, yyyy'}}</span>
                    <span multilang class="emptybtn"></span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:first_month}"></ng-container>
            </div>
            <div class="sec-cal-wrapper">
                <div class="month_header">
                    <span multilang class="emptybtn"></span>
                    <span multilang class="header-txt">{{second_header | date: 'MMMM, yyyy'}}</span>
                    <button (click)="next()" class="dirbtn" matRipple>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:second_month}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mymonth let-month="month">
    <div class="caltab">
        <div class="month-wrapper">
            <span multilang class="mday" *ngFor="let hd of header_week">{{hd }}</span>
        </div>
        <div class="day-wrapper">
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_0}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_1}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_2}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_3}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_4}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_5}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cells let-arr="arr">
    <ng-container *ngFor="let md of arr">
        <ng-container *ngTemplateOutlet="day; context:{md:md}"></ng-container>
    </ng-container>
</ng-template>

<ng-template #day let-md="md">
    <button (click)="selectDay(md)" (mouseleave)="selectTmp_Day(null)" (mouseenter)="selectTmp_Day(md)" class="mday-btn"
        [class.start-date-btn]="md?.id?.length > 0 && ((start?.length > 0 && md.id === start)) && !isOne"
        [class.end-date-btn]="md?.id?.length > 0 && (end?.length > 0 && md.id === end)"
        [class.included]="md?.id > start && (md?.id < tmp_end?.id || md?.id < end) && !isOne"
        [class.disabledday]="!md || md?.id < today" [class.holiday-day]="md?.holiday">
        <span multilang>
            {{ md?.value }}
        </span>
    </button>
</ng-template>